import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    SimpleChanges,
} from '@angular/core';
import { DateTime } from 'luxon';
import {
    formatMonthHeader,
    getShortWeekdays,
} from 'src/app/shared/date/date.utils';
@Component({
    selector: 'app-custom-calendar',
    templateUrl: './custom-calendar.component.html',
    styleUrls: ['./custom-calendar.component.scss'],
    standalone: false
})
export class CustomCalendarComponent implements OnInit {
    @Input() public activeDates: DateTime[] = [];
    @Input() public selectedDate: DateTime | null = null;
    @Output() public dateSelected = new EventEmitter<DateTime>();

    public weeks: DateTime[][] = [];
    public weekDays: string[] = getShortWeekdays();

    public currentMonth: DateTime = DateTime.local();

    public ngOnInit() {
        if (this.activeDates && this.activeDates.length > 0) {
            this.activeDates.sort(
                (a: DateTime, b: DateTime) => a.toMillis() - b.toMillis(),
            );
            this.currentMonth = this.activeDates[0];
        }
        this.generateCalendar();

    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.selectedDate && !changes.selectedDate.firstChange) {
            this.adjustMonthIfNeeded();
        }
    }

    private adjustMonthIfNeeded(): void {
        if (!this.selectedDate) return;

        const selectedMonth = this.selectedDate.startOf('month');
        const currentMonthStart = this.currentMonth.startOf('month');

        // Проверяем, попадает ли selectedDate в текущий отображаемый месяц
        if (!selectedMonth.hasSame(currentMonthStart, 'month')) {
            // Переключаем на нужный месяц
            this.currentMonth = this.selectedDate;
            this.generateCalendar(); // или как называется ваш метод генерации weeks
        }
    }

    public generateCalendar() {
        const start = this.currentMonth.startOf('month').startOf('week');
        const end = this.currentMonth.endOf('month').endOf('week');

        const days: DateTime[] = [];
        let day = start;

        while (day.toMillis() <= end.toMillis()) {
            days.push(day);
            day = day.plus({ days: 1 });
        }

        this.weeks = [];
        while (days.length) {
            this.weeks.push(days.splice(0, 7));
        }
    }

    public isActiveDate(date: DateTime): boolean {
        return this.activeDates.some((activeDate) =>
            date.hasSame(activeDate, 'day'),
        );
    }

    public selectDate(date: DateTime) {
        if (this.isActiveDate(date)) {
            this.selectedDate = date;
            this.dateSelected.emit(date);
        }
    }

    public prevMonth(): void {
        this.currentMonth = this.currentMonth.minus({ months: 1 });
        this.generateCalendar();
    }

    public nextMonth(): void {
        this.currentMonth = this.currentMonth.plus({ months: 1 });
        this.generateCalendar();
    }

    public formatMonth(): string {
        return formatMonthHeader(this.currentMonth);
    }
}
